import type { LayoutProps } from '../../types';

import * as React from 'react';
import { LayoutA as LayoutComponent } from '../../layouts/LayoutA';

export function Layout(props: LayoutProps) {
  const { children, pageContext } = props;
  return (
    <LayoutComponent pageContext={pageContext}>
      {children}
    </LayoutComponent>
  );
}
